import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import {
  cornermarkAddPath,
  CornermarkAddUrlQueryParams,
  cornermarkListPath,
  CornermarkListUrlQueryParams,
  CornermarkListUrlSortField,
  cornermarkPath,
  CornermarkUrlQueryParams
} from "./urls";
import CornermarkCreateComponent from "./views/CornermarkCreate";
import CornermarkDetailsComponent from "./views/CornermarkDetails";
import CornermarkListComponent from "./views/CornermarkList";

const CornermarkList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: CornermarkListUrlQueryParams = asSortParams(
    qs,
    CornermarkListUrlSortField
  );
  return <CornermarkListComponent params={params} />;
};

const CornermarkCreate: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: CornermarkAddUrlQueryParams = qs;
  return <CornermarkCreateComponent params={params} />;
};

const CornermarkDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: CornermarkUrlQueryParams = qs;
  return (
    <CornermarkDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const CornermarkSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.cornermarks)} />
      <Switch>
        <Route exact path={cornermarkListPath} component={CornermarkList} />
        <Route exact path={cornermarkAddPath} component={CornermarkCreate} />
        <Route path={cornermarkPath(":id")} component={CornermarkDetails} />
      </Switch>
    </>
  );
};

export default CornermarkSection;
